var logoutButton = document.querySelector(".logout-button");

logoutButton?.addEventListener('click', () => {
    var logoutDropdown = document.querySelector(".logout-dropdown");
    logoutDropdown?.classList.add("show");
    logoutDropdown?.setAttribute("data-bs-popper", "none");
});
